<template>
    <sa-page-layout :showModalLoading="showModalLoading" :btnRefreshVisible="true" :btnNewVisible="false" :pathResource="pathResource" @refresh="onRefresh" :linkedit="linkedit">
        <template slot="table-body">
            <b-tabs v-if="externalPrenotazioniEnable" id="tabsSchede" nav-wrapper-class="sa-tab-items" content-class="mt-3" ref="tabs" style="height: 100%; padding-bottom: 25px" fill @input="onTabInput" class="sa-tab">
                <b-tab title="Lista Prenotazioni" active>
                    <external-prenotazioni-list-component ref="cmpExternalPrenotazioniList" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" />
                </b-tab>
                <b-tab title="Presa in Carico Prenotazioni">
                    <external-prenotazione-presa-in-carico-component ref="cmpExternalPrenotazionePresaInCaricoComponent" @beforeLoadData="onBeforeLoadDataExternalPrenotazionePresaInCaricoComponent" @afterLoadData="onAfterLoadDataExternalPrenotazionePresaInCaricoComponent" />
                </b-tab>
            </b-tabs>
            <external-prenotazione-presa-in-carico-component v-else ref="cmpExternalPrenotazionePresaInCaricoComponent" @beforeLoadData="onBeforeLoadDataExternalPrenotazionePresaInCaricoComponent" @afterLoadData="onAfterLoadDataExternalPrenotazionePresaInCaricoComponent" />
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ExternalPrenotazioniListComponent from "../components/ExternalPrenotazioniListComponent.vue";
import ExternalPrenotazionePresaInCaricoComponent from "../components/ExternalePrenotazioniListPresaInCaricoComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    components: { SaPageLayout, ExternalPrenotazioniListComponent, ExternalPrenotazionePresaInCaricoComponent },
    mixins: [UtilityMixin],
    computed: {
        rows() {
            return this.items.length;
        },
        externalPrenotazioniEnable: {
            get: function () {
                let me = this;
                return UtilityMixin.methods.verificaPermessi(me.utente, "externalprenotazioni", 1);
            },
        },
    },
    props: {
        utente: {
            required: true,
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            filter: null,
            id: "-1",
            pathResource: "/flussi",
            linkedit: "/struttura",
            filtro: {},
            filterOn: [],
            // externalPrenotazioniEnable: false,
            showModalLoading: false,
            fields: [
                {
                    label: "Tipo",
                    key: "tipo",
                    sortable: false,
                    // thStyle: "width: 0.25rem",
                },
                {
                    label: "Mese Riferimento",
                    key: "meseRiferimento",
                    sortable: false,
                    // thStyle: "width: 0.25rem",
                },
                {
                    label: "Anno Riferimento",
                    key: "annoRiferimento",
                    sortable: false,
                    // thStyle: "width: 0.25rem",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
            items: [
                { tipo: "FILE H", meseRiferimento: "MARZO", annoRiferimento: "2025" },
                { tipo: "FILE H", meseRiferimento: "APRILE", annoRiferimento: "2025" },
            ],
        };
    },
    mounted: function () {
        let me = this;
        // me.externalPrenotazioniEnable = UtilityMixin.methods.verificaPermessi(me.utente, "pazienti", 4);
        me.loadData();
    },
    methods: {
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        loadData() {
            let me = this;
            if (me.externalPrenotazioniEnable) {
                me.$refs.cmpExternalPrenotazioniList.init();
            } else {
                me.$refs.cmpExternalPrenotazionePresaInCaricoComponent.init();
            }
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        // onClickNuovo() {
        //     let me = this;
        //     me.$refs.cmpFlussiModalEdit.show();
        // },
        onAfterSave() {
            let me = this;
            me.loadData();
        },
        onTabInput(tab) {
            switch (tab) {
                case 0:
                    this.$refs.cmpExternalPrenotazioniList.init();
                    break;
                case 1:
                    this.$refs.cmpExternalPrenotazionePresaInCaricoComponent.init();
                    break;

                default:
                    break;
            }
        },
        onBeforeLoadDataExternalPrenotazionePresaInCaricoComponent() {
            console.log("ok");
        },
        onAfterLoadDataExternalPrenotazionePresaInCaricoComponent() {
            console.log("ok");
        },
    },
};
</script>
